import { Editor } from 'tinymce';

// Removes `span` from the DOM and places the collapsed cursor where it used to be.
export function removeSpanAndPlaceCursor(ed: Editor, span: Element) {
	const parent = span.parentNode as Node;
	const spanIdx = Array.from(parent.childNodes).findIndex((n) => n === span);
	ed.dom.remove(span);
	const rng = ed.dom.createRng();
	rng.setStart(parent, spanIdx);
	rng.collapse(true);
	ed.selection.setRng(rng);
}
